import { FormChildQuestionDto, FormQuestionDto } from "@green0meter/api-client";
import React, { FC, memo } from "react";
import { useFormContext } from "react-hook-form";

import {
  FormControl,
  FormControlLabel,
  Checkbox,
  FormGroup,
} from "@components/base";

interface CheckboxInput {
  question: FormQuestionDto | FormChildQuestionDto;
  disabled?: boolean;
}

const CheckboxInput: FC<CheckboxInput> = ({ question, disabled }) => {
  const { setValue, watch } = useFormContext();
  const currentValue: string[] = watch(question.code) || [];

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const { value, checked } = event.target;
    const currentValue = watch(question.code) || [];

    if (checked) {
      setValue(question.code, [...currentValue, value]);
    } else {
      setValue(
        question.code,
        currentValue.filter((v: string) => v !== value),
      );
    }
  };

  return (
    <FormControl component="fieldset" fullWidth disabled={disabled}>
      <FormGroup onChange={handleChange} row>
        {question.answerOptions?.map((option) => (
          <FormControlLabel
            key={option.id}
            control={<Checkbox />}
            label={option.name}
            value={option.code}
            checked={currentValue.includes(option.code)}
          />
        ))}
      </FormGroup>
    </FormControl>
  );
};

export default memo(CheckboxInput);
